var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHuawei(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.734 3C4.80341 3 3 4.80309 3 9.73269V20.2673C3 25.1969 4.80341 27 9.734 27H20.2628C25.1932 27 27 25.1969 27 20.2673V9.73269C27 4.80309 25.1966 3 20.266 3H9.734Z",
    fill: "#64737E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4687 16.9195H14.4322L13.9488 15.7953L13.4687 16.9195ZM13.2314 17.486L12.9456 18.1401H12.2947L13.6788 15.0002H14.2412L15.6197 18.1401H14.9515L14.6693 17.486H13.2314ZM23.7043 18.1378H24.3333V15H23.7043V18.1378ZM21.2007 16.7899H22.3602V16.2177H21.2007V15.5746H22.8839V15.0023H20.5719V18.1399H22.9445V17.5676H21.2007V16.7899ZM18.7014 17.1606L17.9882 15H17.4678L16.7547 17.1606L16.0606 15.0017H15.382L16.4773 18.1419H17.0048L17.7191 16.0792L18.4334 18.1419H18.9656L20.058 15.0017H19.3969L18.7014 17.1606ZM11.3345 16.7986C11.3345 17.3093 11.0808 17.5823 10.6202 17.5823C10.1571 17.5823 9.90206 17.3014 9.90206 16.7768V15.0021H9.26454V16.7986C9.26454 17.6822 9.75565 18.1889 10.6115 18.1889C11.4759 18.1889 11.9714 17.6726 11.9714 16.7723V15.0002H11.3345V16.7986ZM7.74356 15.0002H8.38069V18.1421H7.74356V16.8661H6.30418V18.1421H5.66666V15.0002H6.30418V16.2675H7.74356V15.0002Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 11C12.7942 11 11 9.20563 11 7H11.565C11.565 8.8939 13.1061 10.4348 15 10.4348C16.8939 10.4348 18.435 8.8939 18.435 7H19C19 9.20563 17.2056 11 15 11Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuawei);
export default __webpack_public_path__ + "static/media/huawei.41d51ea5f17b6cf02dcd008a9e2fff5d.svg";
export { ForwardRef as ReactComponent };